import fetchIntercept from 'fetch-intercept';
import {message} from "antd";
import LocalStorageService from "./localStorage-service";

const showMessage = (typeofMessage, content) => {
    message[typeofMessage]({content, style: {marginTop: '45px'}, duration: 2})
};
export default function registerInterceptor() {
    const unregister = fetchIntercept.register({
        request: function (url, config) {
            // Modify the url or config here
            const withDefaults = Object.assign({}, config);
            const token = LocalStorageService.getAuthToken();
            if (config) {
                withDefaults.headers = {...config.headers, Authorization: `Bearer ${token}`};
            } else {
                withDefaults.headers = {
                    Authorization: `Bearer ${token}`
                };
            }
            return [url, withDefaults];
        },
        response: async function (response) {
            if (response.status < 300) {
                return response.json()
            } else if (response.status >= 300 && response.status < 500) {
                const data = await response.json();
                showMessage('error', data.message);
                return Promise.reject(data);
            } else if (response.status >= 500) {
                const data = await response.json();
                console.error(data.message);
            }
        },
    });
}
